import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import colors from "vuetify/es5/util/colors";
import VueScrollTo from "vue-scrollto";

Vue.config.productionTip = false;
//hack for google sheets not working
// window.googleDocCallback = function () {
//   return true;
// };

Vue.use(VueScrollTo);
Vue.use(Vuetify, {
  theme: {
    primary: colors.red.darken1,
    secondary: colors.red.lighten4,
    accent: colors.indigo.base,
  },
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
